import PropTypes from 'prop-types'
import { InfoButton } from 'components/buttons'
import { CheckmarkIcon } from 'components/icons'

export const InCartButton = ({ onClick }) => {
  return (
    <InfoButton
      className="text left"
      onClick={onClick}
      pill
      empty
      style={{ minWidth: 137, padding: 7 }}
    >
      <div className="flex flex-grow align-center">
        <CheckmarkIcon />
        <span className="flex-grow text-center">In Cart</span>
      </div>
    </InfoButton>
  )
}

InCartButton.propTypes = {
  onClick: PropTypes.func,
}

InCartButton.defaultProps = {
  onClick: () => {},
}
